import Table from "../Fusion/Component/Table/Table";
export default Table;
